import * as React from 'react';
import PropTypes from 'prop-types';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import Autocomplete from '@mui/material/Autocomplete';
import TextField from '@mui/material/TextField';
import useGetScoringData from '../hooks/useGetScoringData.js';
import { Card, Text } from "@ui5/webcomponents-react";
import Button from '@mui/material/Button';
import Slide from '@mui/material/Slide';
import Fade from '@mui/material/Fade';
import Container from '@mui/material/Container';
import dayjs from 'dayjs';
import checkmark from "../resources/checkmark_circle.png";
import errorIcon from "../resources/error_circle.png";
import OTPInputGroup from "../components/OTPInputs.js";
import Stack from '@mui/material/Stack';
import LoadingButton from '@mui/lab/LoadingButton';
import HolePanel from '../components/HolePanel.js';
import ScoreCardTable from '../components/ScoreCardTable.js';
import { useTheme } from '../utils/ThemeContext';

// ---------------------------------------------------------------------------
// CustomTabPanel â€” thin wrapper that shows children only when tab is active
// ---------------------------------------------------------------------------
function CustomTabPanel(props) {
  const { children, value, index, ...other } = props;
  

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box pt={2}>
          <Typography component={'span'}>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

CustomTabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

// ---------------------------------------------------------------------------
// Score page
// ---------------------------------------------------------------------------
export default function Score() {
  const { theme } = useTheme();
  const [value, setValue] = React.useState(0);
  const [memberOptions, setMemberOptions] = React.useState([]);
  const [currentCourse, setCurrentCourse] = React.useState([]);
  const [playerOne, setPlayerOne] = React.useState([]);
  const [playerOneScore, setPlayerOneScore] = React.useState([0, 0, 0, 0, 0, 0, 0, 0, 0, 0]);
  const [decrementHoleBtnDisabled, setDecrementHoleBtnDisabled] = React.useState([false, false, false, false, false, false, false, false, false]);
  const [incrementHoleBtnDisabled, setIncrementHoleBtnDisabled] = React.useState([true, true, true, true, true, true, true, true, true]);
  const [selectMemberWarningBoxDisabled, setSelectMemberWarningBoxDisabled] = React.useState("flex");
  const [courseDetailsBoxDisabled, setCourseDetailsBoxDisabled] = React.useState("none");
  const [scorecardDisabled, setScorecardDisabled] = React.useState("none");
  const [submitButtonDisabled, setSubmitButtonDisabled] = React.useState(false);
  const [slideSubmit, setSlideSubmit] = React.useState(false);
  const [slideScoring, setSlideScoring] = React.useState(false);
  const [holeSliders, setHoleSliders] = React.useState([true, false, false, false, false, false, false, false, false]);
  const [holeSliderDirection, setHoleSliderDirection] = React.useState(["down", "left", "left", "left", "left", "left", "left", "left", "left"]);
  const [scoreCardAvailable, setScoreCardAvailable] = React.useState("block");
  const [scoreCardUnavailable, setScoreCardUnavailable] = React.useState("flex");
  const [memberBoxDisabled, setMemberBoxDisabled] = React.useState("flex");
  const [scoreSubmitResponseDisabled, setScoreSubmitResponseDisabled] = React.useState("none");
  const [responseMessage, setResponseMessage] = React.useState("");
  const [responseSuccessImageBox, setResponseSuccessImageBox] = React.useState("");
  const [responseErrorImageBox, setResponseErrorImageBox] = React.useState("");
  const [submitScoreWait, setSubmitScoreWait] = React.useState(true);
  const [otpKey, setOTPKey] = React.useState(true);
  const [oneTimePin, setOneTimePin] = React.useState("");
  const [invalidPin, setInvalidPin] = React.useState(false);
  const [submittingScore, setSubmittingScore] = React.useState(false);
  const [cancelDisabled, setCancelDisabled] = React.useState(false);
  const [highlightHole, setHighlightHole] = React.useState(null);

  const {
    courses: rootData,
    members: rootData2,
  } = useGetScoringData();

  // -------------------------------------------------------------------------
  // Data loading helpers
  // -------------------------------------------------------------------------
  const loadCourses = () => {
    if (rootData) {
      setCurrentCourse(rootData.records[0]);
      if (rootData.records[0].weekCourseAvailable === '1') {
        setScoreCardAvailable("block");
        setScoreCardUnavailable("none");
      } else {
        setScoreCardAvailable("none");
        setScoreCardUnavailable("flex");
      }
    } else {
      setCurrentCourse([]);
      setScoreCardAvailable("none");
      setScoreCardUnavailable("flex");
    }
  };

  //update the update the members state object with the JSON response fro the backend
  const loadMembers = () => {
    if (rootData2) {
      const memberOptionsArr = rootData2.records.map((result) => ({
        label: result.firstName + ' ' + result.lastName,
        id: result.playerID,
      }));
      setMemberOptions(memberOptionsArr);
    }
  };

  // -------------------------------------------------------------------------
  // Submit-button enable/disable
  // -------------------------------------------------------------------------
  // eslint-disable-next-line react-hooks/exhaustive-deps
  const checkSubmitButtonEnabled = () => {
    const scores = [...playerOneScore];
    var disable = true;
    for (let i = 0; i < 9; i++) {
      if (scores[i] === 0) { disable = false; }
    }
    setSubmitButtonDisabled(disable);
  };

  // -------------------------------------------------------------------------
  // Effects
  // -------------------------------------------------------------------------
  React.useEffect(() => {
    if (rootData) {
      loadCourses();
    } else {
      setCurrentCourse([]);
      setScoreCardAvailable("none");
      setScoreCardUnavailable("flex");
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [rootData]);

  React.useEffect(() => {
    if (rootData2) {
      loadMembers();
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [rootData2]);

  React.useEffect(() => {
    checkSubmitButtonEnabled();
  }, [checkSubmitButtonEnabled, submitButtonDisabled]);

  React.useEffect(() => {
    if (responseMessage !== "") {
      setScorecardDisabled("none");
      setScoreSubmitResponseDisabled("flex");
    }
  }, [responseMessage]);

  // -------------------------------------------------------------------------
  // Score helpers
  // -------------------------------------------------------------------------
  const resetScore = (par) => {
    setValue(0);
    const scores = [...playerOneScore];
    const decrementCounterDisabled = [...decrementHoleBtnDisabled]
    decrementCounterDisabled[0] = false
    setDecrementHoleBtnDisabled(decrementCounterDisabled)
    scores[0] = +par;
    for (let i = 1; i < 9; i++) { scores[i] = 0; }
    scores[9] = +par;
    setPlayerOneScore(scores);
    setHoleSliders([true, false, false, false, false, false, false, false, false]);
    setHoleSliderDirection(["down", "left", "left", "left", "left", "left", "left", "left", "left"]);
  };

  // -------------------------------------------------------------------------
  // Member selection
  // -------------------------------------------------------------------------
  const setSelectedMember = (event, newMember) => {
    if (newMember != null) {
      setPlayerOne(newMember);
      setScorecardDisabled("flex");
      setSlideScoring(false);
      const inc = [...incrementHoleBtnDisabled];
      for (let j = 0; j < 9; j++) { inc[j] = false; }
      setIncrementHoleBtnDisabled(inc);
      resetScore(currentCourse.par_1);
      setSelectMemberWarningBoxDisabled("none");
      setCourseDetailsBoxDisabled("flex");
      setSlideScoring((prev) => !prev);
      setHoleSliderDirection(["down", "left", "left", "left", "left", "left", "left", "left", "left"]);
      setMemberBoxDisabled("none");
      event.target.blur();
    }
  };

  // -------------------------------------------------------------------------
  // Score increment / decrement
  // -------------------------------------------------------------------------
  const setPlayerScoreIncrement = (player, index, par) => {
    if (player === 'p1') {
      const scores = [...playerOneScore];
      scores[index] = scores[index] + 1;
      scores[9] = 0;
      for (let i = 0; i < 9; i++) { scores[9] += scores[i]; }
      setPlayerOneScore(scores);
      const scoreButtons = [...decrementHoleBtnDisabled];
      scoreButtons[index] = false;
      setDecrementHoleBtnDisabled(scoreButtons);
      if (scores[index] === (par * 2)) {
        const inc = [...incrementHoleBtnDisabled];
        inc[index] = true;
        setIncrementHoleBtnDisabled(inc);
      }
    }
  };

  const setPlayerScoreDecrement = (player, index, par) => {
    if (player === 'p1') {
      const scores = [...playerOneScore];
      scores[index] = scores[index] - 1;
      scores[9] = 0;
      for (let i = 0; i < 9; i++) { scores[9] += scores[i]; }
      setPlayerOneScore(scores);
      const scoreButtons = [...decrementHoleBtnDisabled];
      scoreButtons[index] = scores[index] === 0;
      setDecrementHoleBtnDisabled(scoreButtons);
      if (scores[index] < (par * 2)) {
        const inc = [...incrementHoleBtnDisabled];
        inc[index] = false;
        setIncrementHoleBtnDisabled(inc);
      }
    }
  };

  // -------------------------------------------------------------------------
  // Navigation handlers
  // -------------------------------------------------------------------------
  const handleNextButton = (nextHole, par) => {
    const scores = [...playerOneScore];
    const sliders = [...holeSliders]
    if (scores[nextHole] === 0) {
      scores[nextHole] = +par;
      scores[9] = +scores[9] + +par;
      setPlayerOneScore(scores);
    }
    setValue(nextHole);
    sliders[+nextHole - 1] = false;
    sliders[nextHole] = true;
    setHoleSliders(sliders);
    const sliderDir = [...holeSliderDirection];
    sliderDir[+nextHole - 1] = "right";
    setHoleSliderDirection(sliderDir);
    setHighlightHole(nextHole);
    setTimeout(() => setHighlightHole(null), 600);
  };

  const handlePreviousButton = (prevHole) => {
    const sliders = [...holeSliders];
    setValue(prevHole);
    sliders[+prevHole + 1] = false;
    sliders[prevHole] = true;
    setHoleSliders(sliders);
    const sliderDir = [...holeSliderDirection];
    sliderDir[+prevHole + 1] = "left";
    setHoleSliderDirection(sliderDir);
    setHighlightHole(prevHole);
    setTimeout(() => setHighlightHole(null), 600);
  };

  // -------------------------------------------------------------------------
  // Score submission
  // -------------------------------------------------------------------------
  const submitScore = () => {
    setSlideScoring((prev) => !prev);
    setSlideSubmit((prev) => !prev);
  };

  const cancelScoreSubmit = () => {
    setSlideScoring((prev) => !prev);
    setSlideSubmit((prev) => !prev);
    setSubmitScoreWait(true);
    setSubmittingScore(false);
    setCancelDisabled(false);
  };

  const setResponseDetails = (data) => {
    if (data.sqlCode === '0') {
      setResponseMessage('Scorecard received for ' + playerOne.label + '. Results are not available until reviewed by the league.');
      setResponseSuccessImageBox("flex");
      setResponseErrorImageBox("none");
      setInvalidPin(false);
    } else if (data.sqlCode === '1') {
      setResponseMessage('You have entered an invalid PIN. Please try again.');
      setResponseSuccessImageBox("none");
      setResponseErrorImageBox("flex");
      setInvalidPin(true);
    } else {
      setResponseMessage('A scorecard has already been received for ' + playerOne.label);
      setResponseSuccessImageBox("none");
      setResponseErrorImageBox("flex");
      setInvalidPin(false);
    }
  };

  const sleep = (ms) => new Promise((r) => setTimeout(r, ms));

  const confirmScoreSubmit = async () => {
    setSubmitScoreWait(true);
    setSubmittingScore(true);
    setCancelDisabled(true);
    await sleep(1000);
    var postData = 'playerID=' + playerOne.id + '&course=' + currentCourse.courseID + '&datePlayed=' + currentCourse.courseDate;
    postData += '&gross1=' + playerOneScore[0];
    postData += '&gross2=' + playerOneScore[1];
    postData += '&gross3=' + playerOneScore[2];
    postData += '&gross4=' + playerOneScore[3];
    postData += '&gross5=' + playerOneScore[4];
    postData += '&gross6=' + playerOneScore[5];
    postData += '&gross7=' + playerOneScore[6];
    postData += '&gross8=' + playerOneScore[7];
    postData += '&gross9=' + playerOneScore[8];
    postData += '&isTourney=0&isFrontNine=0';
    postData += '&otp=' + oneTimePin;

    await fetch(`${process.env.REACT_APP_API_URL}api/scores/create.php`, {
      method: 'POST',
      body: postData,
      headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
    }).then((response) => response.json())
      .then((data) => setResponseDetails(data));
  };

  const handleOTPDataChange = (data) => {
    setSubmitScoreWait(false);
    const buildOTP = data.input1 + data.input2 + data.input3 + data.input4;
    setOneTimePin(buildOTP);
  };

  const resetPage = () => {
    if (invalidPin) {
      setScoreSubmitResponseDisabled("none");
      setScorecardDisabled("flex");
      setResponseMessage("");
      setSubmitScoreWait(true);
      setSubmittingScore(false);
      setCancelDisabled(false);
      setOTPKey((prev) => !prev);
    } else {
      resetScore(currentCourse.par_1)
      setPlayerOne([])
      setMemberBoxDisabled("flex")
      setScoreSubmitResponseDisabled("none")
      setSelectMemberWarningBoxDisabled("flex")
      setSlideSubmit((prev) => !prev)
      //disable the Submit button to the backend
      setSubmitScoreWait(true)
      setSubmittingScore(false);
      setCancelDisabled(false);
      setResponseMessage("");
    }
  };

  // -------------------------------------------------------------------------
  // Render
  // -------------------------------------------------------------------------
  return (
    <>
      {/* Scorecard not available banner */}
      <Box id="noScoreCardAvailable" sx={{ width: '100%' }}
        justifyContent="center" alignItems="center" minHeight="10vh"
        display={scoreCardUnavailable}>
        <table>
          <tbody>
            <tr>
              <td colSpan="2" align="center" style={{ fontSize: "1em" }}>
                The Scorecard is not available for this week
              </td>
            </tr>
          </tbody>
        </table>
      </Box>

      {/* Main scorecard area */}
      <Box display={scoreCardAvailable} id="fullScorecard" sx={{ width: '100%' }}
        justifyContent="center" alignItems="center">

        <Card id="courseAndDateCard" style={{ fontSize: "1.5em" }}>
          <Box style={{ textAlign: "center", fontSize: "1.2em", paddingLeft: "5px", paddingTop: "5px" }}>
            {currentCourse.courseName} - {dayjs(currentCourse.courseDate).format('MMMM D, YYYY')}
          </Box>
        </Card>

        {/* Member selector */}
        <Box id="memberBox" display={memberBoxDisabled}>
          <Card id="memberSelectCard">
            <Box style={{ display: "flex", justifyContent: "center", alignItems: "center" }} pt={1} pb={1} pl={2}>
              <Autocomplete
                disablePortal
                id="playerOneSelect"
                size="small"
                options={memberOptions}
                getOptionLabel={(option) => (option.label ? option.label : '')}
                value={playerOne}
                onChange={(event, newMember) => { setSelectedMember(event, newMember); }}
                isOptionEqualToValue={(options, value) => options.valueOf === value.valueOf}
                sx={{ width: 200 }}
                renderInput={(params) => <TextField {...params} label="Member" />}
              />
            </Box>
          </Card>
        </Box>

        <Box
          justifyContent="center"
          alignItems="center"
          minHeight="10vh"
          display={selectMemberWarningBoxDisabled}
        >
        <table>
            <tbody>
              <tr><td colSpan="2" align="center" style={{fontSize: "1em"}}>Select a Member</td></tr>
            </tbody>
          </table>
      </Box>
        {/* Hole-by-hole scoring â€” one loop replaces 9 nearly-identical blocks */}
        <Slide id="scoreSlider" direction="down" in={slideScoring} timeout={{ enter: 500, exit: 0 }} mountOnEnter unmountOnExit>
          <Container id="scoreContainer">

            {Array.from({ length: 9 }, (_, i) => {
              const holeNum = i + 1;
              return (
                <CustomTabPanel key={i} value={value} index={i}>
                  <HolePanel
                    holeNumber={holeNum}
                    par={currentCourse[`par_${holeNum}`]}
                    menHcp={currentCourse[`men_hcp_${holeNum}`]}
                    womenHcp={currentCourse[`women_hcp_${holeNum}`]}
                    score={playerOneScore[i]}
                    decrementDisabled={decrementHoleBtnDisabled[i]}
                    incrementDisabled={incrementHoleBtnDisabled[i]}
                    display={courseDetailsBoxDisabled}
                    sliderDirection={holeSliderDirection[i]}
                    sliderIn={holeSliders[i]}
                    onDecrement={() => setPlayerScoreDecrement('p1', i, currentCourse[`par_${holeNum}`])}
                    onIncrement={() => setPlayerScoreIncrement('p1', i, currentCourse[`par_${holeNum}`])}
                    onPrev={i > 0 ? () => handlePreviousButton(i - 1) : null}
                    onNext={i < 8 ? () => handleNextButton(i + 1, currentCourse[`par_${holeNum + 1}`]) : null}
                  />
                </CustomTabPanel>
              );
            })}

            {/* Live scorecard */}
            <Box display={scorecardDisabled} pt={4} pl={1} pr={1}>
              <div style={{ width: '100%' }}>
              <Box display="block" style={{ fontWeight: 'bold', paddingBottom: '4px', textAlign: 'center' }}>{playerOne.label}</Box>
              <ScoreCardTable
                scores={playerOneScore}
                course={currentCourse}
                highlight={true}
                highlightHole={highlightHole}
              />
              </div>
            </Box>

            <Box id="submitButtonBox" justifyContent="center" style={{ textAlign: "center" }} pt={3} pl={1} pr={1} pb={2}>
              <Fade in={submitButtonDisabled} timeout={{ enter: 750, exit: 750 }}>
                <Button variant="contained" onClick={() => { submitScore(); }}
                  sx={{ backgroundColor: theme.primary, '&:hover': { backgroundColor: theme.primaryHover }, '&.Mui-disabled': { backgroundColor: theme.primaryDisabled, color: '#fff' } }}
                >Submit</Button>
              </Fade>
            </Box>

          </Container>
        </Slide>
      </Box>

      {/* Score confirmation / PIN entry */}
      <Slide id="submitScoreSlide" direction="up" in={slideSubmit} timeout={{ enter: 1000, exit: 0 }} mountOnEnter unmountOnExit>
        <Container>
          <Box display={scorecardDisabled} pt={2} pl={1} pr={1} pb={2}>
            <div style={{ width: '100%' }}>
            <Box display="block" style={{ fontWeight: 'bold', paddingBottom: '4px', textAlign: 'center' }}>{playerOne.label}</Box>
            <ScoreCardTable
              scores={playerOneScore}
              course={currentCourse}
              highlight={false}
            />
            </div>
          </Box>
          <Box justifyContent="center" display={scorecardDisabled} pt={1} pl={1} pr={1} pb={2}>
            <Stack>
              <Box justifyContent="center" display={scorecardDisabled} pt={2} pl={1} pr={1} pb={1}>
                <Text align="center" style={{ fontSize: "1.1em" }}>
                  To submit your score, enter the PIN you received by email
                </Text>
              </Box>
              <OTPInputGroup key={String(otpKey)} value={oneTimePin} onDataChange={handleOTPDataChange} />
              <Box justifyContent="center">
                <div align="center">
                  <table><tbody>
                    <tr>
                      <td><Button variant="outlined" disabled={cancelDisabled} onClick={() => { cancelScoreSubmit(); }}
                        style={{ borderColor: cancelDisabled ? '#ccc' : theme.primary, color: cancelDisabled ? '#ccc' : theme.primary }}>Cancel</Button></td>
                      <td>
                        <LoadingButton variant="contained" loading={submittingScore} disabled={submitScoreWait}
                          sx={{ backgroundColor: theme.primary, '&:hover': { backgroundColor: theme.primaryHover }, '&.Mui-disabled': { backgroundColor: theme.primaryDisabled, color: '#fff' } }}
                          onClick={() => { confirmScoreSubmit(); }}>
                          {submitScoreWait && <i className="fa fa-refresh fa-spin"></i>}Submit
                        </LoadingButton>
                      </td>
                    </tr>
                  </tbody></table>
                </div>
              </Box>
            </Stack>
          </Box>
        </Container>
      </Slide>

      {/* Submission response card */}
      <Box id="scoreSubmitResponse" display={scoreSubmitResponseDisabled}
        style={{ justifyContent: "center", alignItems: "center" }} pt={2} pl={2} pr={2} pb={3}>
        <Container>
          <Card align="center" style={{ minWidth: "100%" }}>
            <Box pt={5} pl={2} pr={2}>
              <Text style={{ fontSize: "1.25em" }}>{responseMessage}</Text>
            </Box>
            <Box display={responseSuccessImageBox} style={{ justifyContent: "center", alignItems: "center" }} pt={10} pb={5}>
              <Text><img src={checkmark} alt=" " height="90" width="90" /></Text>
            </Box>
            <Box display={responseErrorImageBox} style={{ justifyContent: "center", alignItems: "center" }} pt={10} pb={5}>
              <Text><img src={errorIcon} alt=" " height="90" width="90" /></Text>
            </Box>
          </Card>
          <Box display="flex" style={{ justifyContent: "center", alignItems: "center" }} pt={11}>
            <Button variant="contained" onClick={() => resetPage()}
              sx={{ backgroundColor: theme.primary, '&:hover': { backgroundColor: theme.primaryHover } }}
            >OK</Button>
          </Box>
        </Container>
      </Box>

      <style jsx="true">{`
        table td { font-size: 15px; }
        table th { font-size: 45px; }
        .scoreCardTable {
          width: 100%;
          border-collapse: collapse;
          color: var(--color-body-text);
        }
        .scoreCardHoles {
          background-color: var(--color-scorecard-holes);
          font-size: small;
          height: 40px;
          font-weight: bold;
        }
        .scoreCardHoles td {
          border: 1px solid #000;
          text-align: center;
          width: 30px;
        }
        .scoreCardHandicaps {
          background-color: var(--color-scorecard-hcp);
          font-size: small;
          height: 40px;
          font-weight: bold;
        }
        .scoreCardHandicaps td {
          border: 1px solid #000;
          text-align: center;
        }
        .scoreCardData { height: 30px; font-size: small; }
        .scoreCardData td {
          border: 1px solid #000;
          text-align: center;
          font-size: small;
          width: 30px;
          min-width: 30px;
        }
        .scoreCardPars {
          background-color: var(--color-scorecard-par);
          font-size: small;
          height: 40px;
          font-weight: bold;
        }
        .scoreCardPars td {
          border: 1px solid #000;
          text-align: center;
        }
        .rc-highlight {
          background-color: #FFFFFF;
          font-size: large;
          font-weight: bold;
          transition: all 0.5s ease-in-out;
        }
        input::-webkit-outer-spin-button,
        input::-webkit-inner-spin-button {
          -webkit-appearance: none;
          margin: 0;
        }
        input[type=number] { -moz-appearance: textfield; }
      `}</style>
    </>
  );
}
